import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';
import { useLocalizedPath } from '@/hooks/useLanguage';

export default function Footer() {
  const { t } = useTranslation();
  const localize = useLocalizedPath();

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold text-foreground-950">USFansLink</span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-foreground-600">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('footer.links')}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to={localize('/')} className="text-foreground-600 transition-colors hover:text-primary-600">
                  {t('article.breadcrumb')}
                </Link>
              </li>
              <li>
                <Link to={localize('/usfans-spreadsheet-guide')} className="text-foreground-600 transition-colors hover:text-primary-600">
                  {t('nav.guide')}
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-600 transition-colors hover:text-primary-600">
                  {t('nav.cta')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('dropdown.label')}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-600 transition-colors hover:text-primary-600">
                  {t('cta.primary')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('footer.disclaimer')}</p>
          <p className="mt-4 text-xs text-foreground-500">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}